// extracted by mini-css-extract-plugin
export default {"iata":"kk9-k","additionalInfo":"Leix0","transparent":"MtKq1","AirportIcon":"_1id1X","RailwaysIcon":"iyILn","HotelsIcon":"_4z1t4","MapPointIcon":"Lt9S7","skeleton-progress":"L-ujm"};